module.exports = new __parcel__URL__("mysticalbrilliance.5243a4fa.png").toString();